import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import headerActions from './../../../reusable/Header/Header.actions';
import commonActions from './../../../api/Common.actions';
import { PermissionContext } from './../../../context';
import { userHas, permissions } from "../../../permissions";
import DashboardPestleRiskChart from './components/PESTLEPod/PESTLEChartPod';
import TrendingEntitiesSingleQuery from './components/TrendingEntitiesPodSingleQuery/TrendingEntitiesPod';
import TrendingTerms from './components/TrendingIndexTermPod/TrendingTermsPod';
import SanctionsWarning from './components/SanctionsWarningPod/SanctionsWarningPod';
import InfoPod from './components/Dashboard.infoPod.jsx';
import reduxStore from './../../../reduxStore.js';
import { PERSISTED_FILTERS_MAP } from './../../../constants';
import DashboardFilters from './components/DashboardFilters.jsx';
import { sortBy, forEach } from 'lodash';
import ExperianCreditRatingPod from './components/ExperianCreditRatingPod/ExperianCreditRatingPod';
import ExportDashboardModal from "./components/ExportDashboardModal";

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            entities:           reduxStore.getState().user.preferences.filters.entitiesFilter,
            days:               reduxStore.getState().user.preferences.filters.daysFilter,
            pestle:             reduxStore.getState().user.preferences.filters.pestleFilter,
            risk:               reduxStore.getState().user.preferences.filters.riskFilter,
            language:           reduxStore.getState().user.preferences.filters.languageFilter,
            sanctionedEntities: null,
            finalSanctionEntities: null,
            serverSWEntities : null,
            podSWEntities : null,
            sanctionsOverlay:   {
                overlayVisible: false,
                entityName:     ""
            },
            isExperianEnabled:       reduxStore.getState().user.appSettings.isExperianEnabled,
            allEntitiesWithExperian: null
        };

        this.togglePodsSection = this.togglePodsSection.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.handleFilterVisibility = this.handleFilterVisibility.bind(this);
        this.toggleSanctionsOverlay = this.toggleSanctionsOverlay.bind(this);
        this.handleSWFilterChange = this.handleSWFilterChange.bind(this);
        this.swFromServer = this.swFromServer.bind(this);
        this.sanctionsHandler = this.sanctionsHandler.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader('getStartedDashboard');
    }

    togglePodsSection() {
        let prefs = this.props.userPreferences.dashboard;
        let updatedPrefs = Object.assign(prefs, {isPodsSectionCollapsed: !this.props.userPreferences.dashboard.isPodsSectionCollapsed})
        commonActions.updateDashboardPrefs({ ...updatedPrefs });
    }

    /**
     * Wrapper function, debounced filter updating action
     */
    updateFilters(filters, userFilters) {
        this.setState({ ...filters });
        commonActions.updateUserFilters({ ...userFilters });
    }

    toggleSanctionsOverlay() {
        this.setState({
            sanctionsOverlay: { ...this.state.sanctionsOverlay, overlayVisible: !this.state.sanctionsOverlay.overlayVisible, entityName:"Microsoft" }
        })
    }

    handleSWFilterChange() {
        if (this.state.serverSWEntities === null) {
            this.setState({finalSanctionEntities: null});
        } else {
            let sortedEntities = sortBy(this.state.serverSWEntities, ['title']);
            this.setState({finalSanctionEntities: sortedEntities});
        }

    }

    swFromServer(sw) {
        this.setState({serverSWEntities: sw}, this.handleSWFilterChange);
    }

    sanctionsHandler(entities) {
        this.setState({sanctionedEntities: entities});
    }

    displayExportDashboardModal = () => {
        const activeModal = (
            <ExportDashboardModal
                isModalLoading={false}
                dashboardState={this.state}
                secondaryAction={this.closeModal}
            />
        );
        this.setState({ activeModal });
    };

    closeModal = () => {
        this.setState({ activeModal: null });
    };

    handleFilterVisibility(filter) {
        let prefs = this.props.userPreferences.dashboard;
        const filterKey = PERSISTED_FILTERS_MAP[filter];
        let updatedPrefs = Object.assign(prefs, {[filterKey]: !this.props.userPreferences.dashboard[filterKey]});

        commonActions.updateDashboardPrefs({ ...updatedPrefs });
    }

    render() {
        let persistedFiltersVisibility = {};
        forEach(PERSISTED_FILTERS_MAP, (value, key) => {
            persistedFiltersVisibility[key] = this.props.userPreferences.dashboard[value];
        });

        let hasActiveEntities = this.props.data.active > 0;

        return (
            <div className="dashboard-page">

                <div className="section-header" onClick={this.togglePodsSection}>
                    <span className={!this.props.userPreferences.dashboard.isPodsSectionCollapsed ? 'la-TriangleDown' :
                        'la-TriangleRight'}></span>
                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.sectionHeader.overview" />
                </div>
                {
                    this.props.userPreferences.dashboard.isPodsSectionCollapsed ? null :
                        <div className="notranslate dashboard-page__pods">
                            <PermissionContext.Provider value={{ canEdit: userHas(permissions.entities.edit) }}>
                                <InfoPod data={this.props.data.active}
                                         text={this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.pod.activeEntities'})}
                                         link="/manage-third-parties"
                                         linkText={this.props.intl.formatMessage(
                                             {id: 'Dashboard_Charts_UIText_dashboard.pod.activeEntitiesUrl'})} />
                                <InfoPod data={this.props.data.inactive}
                                         text={this.props.intl.formatMessage(
                                             {id: 'Dashboard_Charts_UIText_dashboard.pod.entitiesAwaitingActivation'})}
                                         link="/review-companies"
                                         linkText={this.props.intl.formatMessage(
                                             {id: 'Dashboard_Charts_UIText_dashboard.pod.entitiesAwaitingActivationUrl'})} />
                                <InfoPod data={this.props.data.subscription}
                                         subscription={this.props.data.subscription - this.props.data.active -
                                         this.props.data.inactive}
                                         text={this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.pod.availableInPlan'})}
                                         link="/upload"
                                         linkText={this.props.intl.formatMessage(
                                             {id: 'Dashboard_Charts_UIText_dashboard.pod.availableInPlanUrl'})} />
                            </PermissionContext.Provider>
                            <PermissionContext.Provider value={{ canEdit: userHas(permissions.feeds.edit) }}>
                                <InfoPod data={this.props.data.rss}
                                         text={this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.pod.activeRssFeeds'})}
                                         link="/feeds"
                                         linkText={this.props.intl.formatMessage(
                                             {id: 'Dashboard_Charts_UIText_dashboard.pod.activeRssFeedsUrl'})} />
                            </PermissionContext.Provider>
                        </div>
                }

                <div className="section-header entities-analysis">
                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.sectionHeader.entitiesAnalysis" />
                    <button
                        onClick={this.displayExportDashboardModal}
                        className={'button-primary-lg export-dashboard'}
                        disabled={!hasActiveEntities}>
                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_export"/>
                        <span className="la-Excel"></span>
                    </button>
                </div>
                {
                    this.props.userPreferences.isTrendingAndStatisticsCollapsed ? null :
                        <div className="dashboard-page__columns">
                            <DashboardFilters
                                onToggleVisibility={this.handleFilterVisibility}
                                filtersCollapsed={persistedFiltersVisibility}
                                changeHandler={this.updateFilters}
                                filtersState={this.state} />
                            <div className="dashboard-page__results">
                                <div className="dashboard-page__trending">
                                    <SanctionsWarning
                                        swEntities={this.state.finalSanctionEntities}
                                        days={this.state.days}
                                        entities={this.state.entities}
                                        pestle={this.state.pestle}
                                        risk={this.state.risk}
                                        loadComplete={this.swFromServer}
                                    />
                                    <TrendingEntitiesSingleQuery
                                        days={this.state.days}
                                        entities={this.state.entities}
                                        pestle={this.state.pestle}
                                        risk={this.state.risk}
                                        language={this.state.language}
                                    />


                                    {this.state.isExperianEnabled && (
                                        <ExperianCreditRatingPod days={this.state.days}
                                                                 entities={this.state.entities}
                                                                 pestle={this.state.pestle}
                                                                 risk={this.state.risk}
                                                                 language={this.state.language} />
                                    )}

                                    <TrendingTerms
                                        days={this.state.days}
                                        entities={this.state.entities}
                                        pestle={this.state.pestle}
                                        risk={this.state.risk}
                                        language={this.state.language}
                                    />
                                </div>

                                <div className="dashboard-page__statistics">
                                    <DashboardPestleRiskChart
                                        days={this.state.days}
                                        category={this.state.category}
                                        entities={this.state.entities}
                                        pestle={this.state.pestle}
                                        risk={this.state.risk}
                                        language={this.state.language}
                                    />
                                    <p className="dashboard-page__statistics__utc-node">* <FormattedMessage
                                        id="Dashboard_CoreFunctionality_UIText_dashboard.allDatesUTC" /></p>
                                </div>
                            </div>
                        </div>
                }
                {this.state.activeModal}
            </div>

        );
    }
}

export default injectIntl(Dashboard);



// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/Dashboard.jsx